import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  customerList,
  customerCreateReset,
  customerCreate,
  customerUpdate,
  customerDelete,
  customerSelect,
  countryStateList,
  getDeviceRepositoryAll,
} from '../../redux/actions'

import {
  getActiveLanguage
} from 'react-localize-redux'

import { removeLogo } from '../../common/storage'

import {
  preparePager,
  prepareSearch
} from '../../common/tabletools'

import NoData from '../../components/nodata'
import Organisations from '../../components/organisations'

class OrganisationsPage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      pager: {
        defaultColumns: ['name', 'contact', 'contactemail', 'telephoneno', 'deviceupdaterepositoryname', 'enabledevicetypes'],
        manual: true,
        pageno: 1,
        pagesize: 5,
        order: {},
        search: [],
        global: false
      }
    }
    this.fetch = this.fetch.bind(this);
    this.search = this.search.bind(this);
  }

  componentWillMount() {
    this.props.reset();
    this.props.getCustomers(this.state.pager);
    this.props.getCountryStateList(this.props.activeLanguage);
    this.props.getDeviceRepositoryAll();
  }

  fetch(table) {
    const { pager } = this.state
    if (!pager.global)
    this.props.getCustomers(preparePager(table, pager))
    else {
      let search = pager.search
      let pagers = preparePager(table, pager)
      if (pagers.search.length > 0) {
        pagers.search = [...search, ...pagers.search]
      }
      else {
        pagers.search = search
      }
      this.props.getCustomers(pagers)
    }
  }

  search(term) {
    const { customers } = this.props
    const { columns } = customers
    const { pager } = this.state
    const _pager = prepareSearch(term, columns, pager)
    _pager.global = term === '' ? false : true
    this.setState({
      pager: _pager
    })

    this.props.getCustomers(_pager)
  }

  removeLogo(id) {
    removeLogo('org', id)
  }

  render() {
    const {
      translate,
      languages,
      create,
      created,
      customerId,
      customer,
      customers,
      getCustomer,
      update,
      del,
      reset,
      countryStates,
      roles,
      allRepositories,
      configs
    } = this.props

    const {
      pager
    } = this.state

    return (
      (customers) ? (
        <Organisations
          translate={translate}
          languages={languages}
          create={create}
          created={created}
          customerId={customerId}
          customer={customer}
          customers={customers}
          pager={pager}
          update={update}
          fetch={this.fetch}
          search={this.search}
          reset={reset}
          get={getCustomer}
          del={del}
          removeLogo={ this.removeLogo }
          countryStates={countryStates}
          roles={roles}
          allRepositories={allRepositories}
          configs={configs}
        />
      ) : (
          <NoData translate={translate} />
        )
    )
  }
}

const mapStateToProps = (state) => ({
  languages: state.localeReducer.languages,
  customerId: state.customerReducer.customerId,
  customer: state.customerReducer.customer,
  customers: state.customerReducer.customers,
  created: state.customerReducer.created,
  updated: state.customerReducer.updated,
  countryStates: state.customerReducer.countryStates,
  activeLanguage: getActiveLanguage(state.localeReducer).code,
  allRepositories: state.deviceRepositoryReducer.allRepositories,
  configs: state.authReducer.configs,
  ...state,
})

const mapDispatchToProps = (dispatch, props) => ({
  getCustomers: (pager) => {
    dispatch(customerList(pager))
  },
  create: (customer, pager) => {
    return dispatch(customerCreate('org', customer, pager))
  },
  update: (customer, pager) => {
    return dispatch(customerUpdate('org', customer, pager))
  },
  getCustomer: (id) => {
    dispatch(customerSelect(id))
  },
  reset: () => {
    dispatch(customerCreateReset())
  },
  del: (id, pager) => {
   return dispatch(customerDelete('org', id, pager))
  },
  getCountryStateList: (languageCode) => {
    dispatch(countryStateList(languageCode));
  },
  getDeviceRepositoryAll: () => {
    dispatch(getDeviceRepositoryAll())
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(OrganisationsPage)
